import { utils, write, writeFile, writeBuffer } from "xlsx";
import { saveAs } from "file-saver";
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";

export function convertStringsToNumbers(input) {
  if (typeof input === "string" && input !== "" && !isNaN(input)) {
    return parseFloat(input);
  } else if (Array.isArray(input)) {
    return input.map((item) => convertStringsToNumbers(item));
  } else if (typeof input === "object" && input !== null) {
    const newObj = Array.isArray(input) ? [] : {};
    for (const key in input) {
      if (input.hasOwnProperty(key)) {
        newObj[key] = convertStringsToNumbers(input[key]);
      }
    }
    return newObj;
  }
  return input;
}

export const generateExcelFile = (data, fileName) => {
  // Create a new workbook
  const workbook = utils.book_new();

  // Convert the array of objects to a worksheet
  const worksheet = utils.json_to_sheet(data);

  // Add the worksheet to the workbook
  utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Generate Excel file binary data
  const excelData = write(workbook, { type: "binary" });

  // Convert the binary data to a Blob
  const excelBlob = new Blob([s2ab(excelData)], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create a File object with the Blob and the desired file name
  const file = new File([excelBlob], fileName, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return file;
};

// Utility function to convert string to ArrayBuffer
export const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
};

export const generateCSVFile = (data) => {
  // Convert the array of objects to CSV format
  const csvData = convertArrayToCSV(data);

  // Convert the CSV data to a Blob
  const csvBlob = new Blob([csvData], {
    type: "text/csv;charset=utf-8",
  });

  // Create a File object with the Blob
  const file = new File([csvBlob], "data_ready.csv", {
    type: "text/csv;charset=utf-8",
  });

  return file;
};

// Utility function to convert array of objects to CSV format
export const convertArrayToCSV = (data) => {
  const csvRows = [];

  // Extract the headers from the first object
  const headers = Object.keys(data[0]);

  // Create the header row
  csvRows.push(headers.join(","));

  // Iterate over the data and create rows
  for (const object of data) {
    const values = headers.map((header) => object[header]);
    csvRows.push(values.join(","));
  }

  // Join all the rows with newline character
  return csvRows.join("\n");
};

// export function exportToXLSX(excelData, columnSequence, filename) {
//   const fileType =
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
//   const fileExtension = ".xlsx";
//   const exportToExcel = async () => {
//     const ws = XLSX.utils.json_to_sheet(excelData);
//     const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const data = new Blob([excelBuffer], { type: fileType });
//     FileSaver.saveAs(data, filename + fileExtension);
//   };
//   exportToExcel();
// }

export function exportToXLSX(excelData, columnSequence, filename) {
  function reorderData(data, columnSequence) {
    // Create a new array with the columns in the desired order
    return data.map((item) => {
      const reorderedItem = {};
      for (const columnName of columnSequence) {
        reorderedItem[columnName] = item[columnName];
      }
      return reorderedItem;
    });
  }
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
  const fileExtension = ".xlsx";
  const exportToExcel = async () => {
    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(reorderData(excelData, columnSequence));

    // Create a workbook
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    // Convert the workbook to an XLSX format
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob and save the file
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename + fileExtension);
  };

  exportToExcel();
}
